import { Views } from '@neos/app'
import { OpenModeType, PopupPosition } from '@neos/shared'

export const views: Views = {
  default: [
    {
      name: 'AssignPermissionToRolesListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/AssignPermissionToRolesListUI/AssignPermissionToRolesListUI.vue'),
    },
    {
      name: 'AssignPermissionToRolesUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/AssignPermissionToRolesUI/AssignPermissionToRolesUI.vue'),
    },
    {
      name: 'BackgroundServerMethodCallCaptureUI',
      openMode: OpenModeType.popupFullSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/BackgroundServerMethodCallCaptureUI/BackgroundServerMethodCallCaptureUI.vue'),
    },
    {
      name: 'BackgroundServerMethodTriggersUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/BackgroundServerMethodTriggersUI/BackgroundServerMethodTriggersUI.vue'),
    },
    {
      name: 'ClusterTemporaryStorageCleanupTaskEditUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ClusterTemporaryStorageCleanupTaskEditUI/ClusterTemporaryStorageCleanupTaskEditUI.vue'),
    },
    {
      name: 'CultureListUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CultureListUI/CultureListUI.vue'),
    },
    {
      name: 'CustomSubUIViewEntityViewParameterUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomSubUIViewEntityViewParameterUI/CustomSubUIViewEntityViewParameterUI.vue'),
    },
    {
      name: 'CustomSubUIViewPropertyUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomSubUIViewPropertyUI/CustomSubUIViewPropertyUI.vue'),
    },
    {
      name: 'CustomSubUIViewStyleRuleUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomSubUIViewStyleRuleUI/CustomSubUIViewStyleRuleUI.vue'),
    },
    {
      name: 'CustomSubUIViewUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomSubUIViewUI/CustomSubUIViewUI.vue'),
    },
    {
      name: 'CustomUIViewCreateUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomUIViewCreateUI/CustomUIViewCreateUI.vue'),
    },
    {
      name: 'CustomUIViewDataFilterUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomUIViewDataFilterUI/CustomUIViewDataFilterUI.vue'),
    },
    {
      name: 'CustomUIViewEntityViewParameterUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomUIViewEntityViewParameterUI/CustomUIViewEntityViewParameterUI.vue'),
    },
    {
      name: 'CustomUIViewGroupsUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomUIViewGroupsUI/CustomUIViewGroupsUI.vue'),
    },
    {
      name: 'CustomUIViewListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomUIViewListUI/CustomUIViewListUI.vue'),
    },
    {
      name: 'CustomUIViewPropertyUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomUIViewPropertyUI/CustomUIViewPropertyUI.vue'),
    },
    {
      name: 'CustomUIViewSortsUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomUIViewSortsUI/CustomUIViewSortsUI.vue'),
    },
    {
      name: 'CustomUIViewStyleRuleUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomUIViewStyleRuleUI/CustomUIViewStyleRuleUI.vue'),
    },
    {
      name: 'DashboardUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DashboardUI/DashboardUI.vue'),
    },
    {
      name: 'EmojiListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/EmojiListUI/EmojiListUI.vue'),
    },
    {
      name: 'HomePageUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/HomePageUI/HomePageUI.vue'),
    },
    {
      name: 'KnownIanaTimeZoneUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/KnownIanaTimeZoneUI/KnownIanaTimeZoneUI.vue'),
    },
    {
      name: 'NeosBaseUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosBaseUI/NeosBaseUI.vue'),
    },
    {
      name: 'PermissionUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/PermissionUI/PermissionUI.vue'),
    },
    {
      name: 'QuartzNetAddTriggerUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/QuartzNetAddTriggerUI/QuartzNetAddTriggerUI.vue'),
    },
    {
      name: 'QuartzNetFiredTestJobUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/QuartzNetFiredTestJobUI/QuartzNetFiredTestJobUI.vue'),
    },
    {
      name: 'QuartzNetTestTriggerUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/QuartzNetTestTriggerUI/QuartzNetTestTriggerUI.vue'),
    },
    {
      name: 'QuartzNetTriggerUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/QuartzNetTriggerUI/QuartzNetTriggerUI.vue'),
    },
    {
      name: 'RecentlyRunScheduledTasksUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/RecentlyRunScheduledTasksUI/RecentlyRunScheduledTasksUI.vue'),
    },
    {
      name: 'RemoteScheduledTaskExecutionDetailsUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/RemoteScheduledTaskExecutionDetailsUI/RemoteScheduledTaskExecutionDetailsUI.vue'),
    },
    {
      name: 'RemoteScheduledTaskExecutionListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/RemoteScheduledTaskExecutionListUI/RemoteScheduledTaskExecutionListUI.vue'),
    },
    {
      name: 'RemoteScheduledTaskListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/RemoteScheduledTaskListUI/RemoteScheduledTaskListUI.vue'),
    },
    {
      name: 'ScheduledTaskEditUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ScheduledTaskEditUI/ScheduledTaskEditUI.vue'),
    },
    {
      name: 'ScheduledTaskExecutionDetailsUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ScheduledTaskExecutionDetailsUI/ScheduledTaskExecutionDetailsUI.vue'),
    },
    {
      name: 'ScheduledTaskExecutionListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ScheduledTaskExecutionListUI/ScheduledTaskExecutionListUI.vue'),
    },
    {
      name: 'ScheduledTaskExecutionLogAdditionalDataUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ScheduledTaskExecutionLogAdditionalDataUI/ScheduledTaskExecutionLogAdditionalDataUI.vue'),
    },
    {
      name: 'ScheduledTaskExecutionLogSearchUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ScheduledTaskExecutionLogSearchUI/ScheduledTaskExecutionLogSearchUI.vue'),
    },
    {
      name: 'ScheduledTaskExecutionSearchUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ScheduledTaskExecutionSearchUI/ScheduledTaskExecutionSearchUI.vue'),
    },
    {
      name: 'ScheduledTaskListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ScheduledTaskListUI/ScheduledTaskListUI.vue'),
    },
    {
      name: 'ScheduledTaskSearchUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ScheduledTaskSearchUI/ScheduledTaskSearchUI.vue'),
    },
    {
      name: 'SchedulerTriggerEditUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/SchedulerTriggerEditUI/SchedulerTriggerEditUI.vue'),
    },
    {
      name: 'UserAccountAvailableUI',
      openMode: OpenModeType.popupFullSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountAvailableUI/UserAccountAvailableUI.vue'),
    },
    {
      name: 'UserAccountListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountListUI/UserAccountListUI.vue'),
    },
    {
      name: 'UserAccountLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountLookupUI/UserAccountLookupUI.vue'),
    },
    {
      name: 'UserAccountUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountUI/UserAccountUI.vue'),
    },
    {
      name: 'UserAccountUserRoleEntityUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountUserRoleEntityUI/UserAccountUserRoleEntityUI.vue'),
    },
    {
      name: 'UserAccountUserRoleMultiClusterUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountUserRoleMultiClusterUI/UserAccountUserRoleMultiClusterUI.vue'),
    },
    {
      name: 'UserAccountUserRoleUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountUserRoleUI/UserAccountUserRoleUI.vue'),
    },
    {
      name: 'UserPermissionUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserPermissionUI/UserPermissionUI.vue'),
    },
    {
      name: 'UserReportPrintSettingsJobUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserReportPrintSettingsJobUI/UserReportPrintSettingsJobUI.vue'),
    },
    {
      name: 'UserReportPrintSettingsListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserReportPrintSettingsListUI/UserReportPrintSettingsListUI.vue'),
    },
    {
      name: 'UserReportPrintSettingsUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserReportPrintSettingsUI/UserReportPrintSettingsUI.vue'),
    },
    {
      name: 'UserRoleAssignmentUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserRoleAssignmentUI/UserRoleAssignmentUI.vue'),
    },
    {
      name: 'UserSettingsUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserSettingsUI/UserSettingsUI.vue'),
    },
  ],
}
